import { ECouponStatus, ECouponType } from '@web/core/models';
import { RequestCoupon } from './request-coupon.model';

export class UserCoupon extends RequestCoupon {
  cid: string;
  couponCode: string;
  userEmail: string;
  couponType: ECouponType;
  status: ECouponStatus;
  isEditable: boolean;
  requestedOn: Date;
  expiresOn: Date;
  spentAmount?: number;
  spentThreshold?: number;
  spentUpdateOn?: Date;

  constructor(data: Partial<UserCoupon> = {}) {
    super(data);
    if (data.couponType) {
      this.couponType = data.couponType as ECouponType;
    }
    if (data.status) {
      this.status = data.status as ECouponStatus;
    }
    if (data.requestedOn) {
      this.requestedOn = new Date(data.requestedOn);
    }
    if (data.expiresOn) {
      this.expiresOn = new Date(data.expiresOn);
    }
    if (data.spentUpdateOn) {
      this.spentUpdateOn = new Date(data.spentUpdateOn);
    }
  }

  get serialised() {
    return {
      id: this.id,
      cid: this.cid,
      couponCode: this.couponCode,
      userFirstName: this.userFirstName,
      userLastName: this.userLastName,
      userEmail: this.userEmail,
      couponType: this.couponType,
      status: this.status,
      isEditable: this.isEditable,
      requestedOn: this.requestedOn,
      expiresOn: this.expiresOn,
      spentAmount: this.spentAmount,
      spentThreshold: this.spentThreshold,
      spentUpdateOn: this.spentUpdateOn,
    };
  }
}
